import React, { useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import { withRouter, Route, Switch, Link } from "react-router-dom";
import { URLS } from "../../urls";
import { Helmet } from "react-helmet";
import Cookies from "universal-cookie";
import moment from "moment";
import UserTopbar from "../user-topbar/UserTopbar";
import UserSidebar from "../user-sidebar/UserSidebar";
import ApplyLeaveModal from "./ApplyLeaveModal";
import EditLeaveModal from "./EditLeaveModal";
import DeleteLeaveModal from "./DeleteLeaveModal";
import { branch_id } from "../../../utils";
import { CalendarCheck2, CalendarDays, CalendarMinus } from "../../icons";
import { LeavePopOver } from "../../leaves/LeavesPopOver";
const allMonths = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];
const UserDashBoardLeaves = (props) => {
  const [state, setState] = useState({
    appliedLeaves: [],
    loggedEmployee: null,
    selectedLeave: null,
    leaveTypes: [],
    userLeaveBalance: null,
    totalLeaves: 0,
    totalRemaining: 0,
  });

  const componentDidMount = () => {
    const token = "dummy token";
    const cookies = new Cookies();
    const id = cookies.get("userId");
    fetch(`${URLS.backendApplyLeaves}/getByUserId/${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    })
      .then((res) => res.json())
      .then((result) => {
        setState((el) => ({
          ...el,
          appliedLeaves: result.applyLeaves,
        }));
      });

    fetch(`${URLS.backendLeaveBalances}/getByUserId/${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.leaveBalance) {
          const totalLeaves = result.leaveBalance.leavesAvailable.reduce(
            (total, leave) => total + leave.total,
            0
          );

          const totalRemaining = result.leaveBalance.leavesAvailable.reduce(
            (total, leave) => total + leave.remaining,
            0
          );

          setState((el) => ({
            ...el,
            leaveTypes: result.leaveBalance.leavesAvailable,
            userLeaveBalance: result.leaveBalance,
            totalLeaves,
            totalRemaining,
          }));
        }
      });

    fetch(`${URLS.backendEmployees}/getShortInfoByUserId/${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    })
      .then((res) => res.json())
      .then((result) => {
        setState((el) => ({
          ...el,
          loggedEmployee: result.employee,
        }));
      });

    fetch(`${URLS.backendLeaves}/checkLeaveYearly?branch_id=${branch_id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    })
      .then((res) => res.json())
      .then((result) => {});
  };

  useEffect(() => {
    let isMounted = true;

    if (isMounted) {
      componentDidMount();
    }

    return () => {
      isMounted = false;
    };
  }, []);

  const updatdeSelectedLeave = (appliedLeave) => {
    setState((el) => ({
      ...el,
      selectedLeave: appliedLeave,
    }));
  };

  const updateAppliedLeavesList = (appliedLeave) => {
    let { appliedLeaves } = state;
    const id = appliedLeave && appliedLeave._id;
    let isExists = false;
    for (let index = appliedLeaves.length - 1; index >= 0; --index) {
      if (appliedLeaves[index]._id === id) {
        appliedLeaves.splice(index, 1);
        appliedLeaves.splice(index, 0, appliedLeave);
        isExists = true;
        break;
      }
    }
    if (isExists) {
      setState((el) => ({ ...el, appliedLeaves: appliedLeaves }));
    } else {
      setState((el) => ({
        ...el,
        appliedLeaves: [appliedLeave].concat(appliedLeaves),
      }));
    }
    getUpdatedLeaveBalance();
  };
  const removeLeaveFormAppliedLeavesList = (deletedLeave) => {
    let { appliedLeaves } = state;
    const id = deletedLeave && deletedLeave._id;
    for (let index = appliedLeaves.length - 1; index >= 0; --index) {
      if (appliedLeaves[index]._id === id) {
        appliedLeaves.splice(index, 1);
        break;
      }
    }
    getUpdatedLeaveBalance();
    setState((el) => ({ ...el, appliedLeaves: appliedLeaves }));
  };
  const getUpdatedLeaveBalance = () => {
    const token = "dummy token";
    const cookies = new Cookies();
    const id = cookies.get("userId");
    fetch(`${URLS.backendLeaveBalances}/getByUserId/${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.leaveBalance) {
          setState((el) => ({
            ...el,
            leaveTypes: result.leaveBalance.leavesAvailable,
            userLeaveBalance: result.leaveBalance,
          }));
        }
      });
  };

  const checkIfLeaveFinished = (date, status) => {
    let data;

    const check = moment(new Date()).isAfter(moment(date));

    if (status === "New" || status === "Pending") {
      data = (
        <p className="dropdown-item pending" href="#">
          {" "}
          Pending
        </p>
      );
    } else if (status === "Declined") {
      data = (
        <p className="dropdown-item rejected" href="#">
          {" "}
          Inactive
        </p>
      );
    } else {
      if (!check) {
        data = (
          <p className="dropdown-item open-active" href="#">
            {" "}
            Active
          </p>
        );
      } else {
        data = (
          <p className="dropdown-item shortlisted" href="#">
            {" "}
            Finished
          </p>
        );
      }
    }
    return data;
  };

  const showDateInFormat = (date, normal) => {
    date = date.split("/");

    let newDate;

    if (date[0] === "Invalid date") {
      newDate = normal;
    } else {
      newDate =
        ("0" + date[0]).slice(-2) +
        " " +
        allMonths[date[1] - 1] +
        " " +
        date[2];
    }

    return newDate;
  };

  const calculateDays = (days) => {
    return days > 1 ? `${days} days ` : `${days} day`;
  };

  const {
    userLeaveBalance,
    appliedLeaves,
    leaveTypes,
    selectedLeave,
    loggedEmployee,
    totalLeaves,
    totalRemaining,
  } = state;

  const cleanedData = useMemo(() => {
    const uniqueNames = [
      ...new Set(
        userLeaveBalance?.leavesAvailable?.map((el) => `${el.name}-${el._id}`)
      ),
    ];
    const result = [];
    for (let index = 0; index < uniqueNames.length; index++) {
      const item = uniqueNames[index];

      let totalCount = 0;
      let totalRemaining = 0;
      let totalTaken = 0;

      const name = item.split("-")[0];
      const id = item.split("-")[1];

      for (
        let index = 0;
        index < userLeaveBalance?.leavesAvailable?.length;
        index++
      ) {
        if (userLeaveBalance?.leavesAvailable[index].name === name) {
          totalCount += userLeaveBalance?.leavesAvailable[index]?.total;
          totalRemaining += userLeaveBalance?.leavesAvailable[index]?.remaining;
        }
      }

      for (
        let index = 0;
        index < userLeaveBalance?.takenLeaves?.length;
        index++
      ) {
        if (userLeaveBalance?.takenLeaves[index]._id === id) {
          totalTaken += userLeaveBalance?.takenLeaves[index]?.taken;
        }
      }

      const data = {
        name,
        totalCount,
        totalRemaining,
        totalTaken,
      };

      result.push(data);
    }
    return result;
  }, [userLeaveBalance?.leavesAvailable, userLeaveBalance?.takenLeaves]);

  return (
    <body>
      <Helmet>
        <meta charSet="utf-8" />
        <meta name="robots" content="noindex, nofollow"></meta>
        <title>InvexERP</title>
      </Helmet>
      <div className="main-wrapper">
        <UserTopbar />
        <UserSidebar />
        {/*<!-- Page Wrapper -->*/}
        <div className="page-wrapper">
          {/*<!-- Page Content -->*/}
          <div className="content container-fluid">
            {/*<!-- Page Title -->*/}
            <div className="row">
              <div className="col-sm-8 col-6">
                <h4 className="page-title">Leaves</h4>
              </div>
              <div className="col-sm-4 col-6 text-right m-b-30">
                <a
                  href="javaScript:void(0);"
                  className="btn add-btn"
                  data-toggle="modal"
                  data-target="#add_leave"
                >
                  <i className="fa fa-plus"></i> Apply Leave
                </a>
              </div>
            </div>
            {/*<!-- /Page Title -->*/}

            {/*<!-- Leave Statistics -->*/}
            <section className="stats">
              <div className="stat-alt">
                <div className="icon icon-alt icon-1">
                  <CalendarDays />
                </div>
                <div className="details details-alt ">
                  <h1 className="dark-text text-20 font-500 m-0">
                    {totalLeaves?.toFixed(1)}
                  </h1>

                  <p className="text-gray-400 font-400 text-14">
                    Total Leave{" "}
                    <LeavePopOver cleanedData={cleanedData} type="totalCount" />{" "}
                  </p>
                </div>
              </div>
              <div className="stat-alt">
                <div className="icon icon-alt icon-1">
                  <CalendarCheck2 />
                </div>
                <div className="details details-alt ">
                  <h1 className="dark-text text-20 font-500 m-0">
                    {userLeaveBalance
                      ? userLeaveBalance.totalAvailable?.toFixed(1) -
                        userLeaveBalance.totalRemaining?.toFixed(1)
                      : 0}
                  </h1>

                  <p className="text-gray-400 font-400 text-14">
                    Taken Leave{" "}
                    <LeavePopOver cleanedData={cleanedData} type="totalTaken" />{" "}
                  </p>
                </div>
              </div>
              <div className="stat-alt">
                <div className="icon icon-alt icon-1">
                  <CalendarMinus />
                </div>
                <div className="details details-alt ">
                  <h1 className="dark-text text-20 font-500 m-0">
                    {totalRemaining?.toFixed(1)}
                  </h1>

                  <p className="text-gray-400 font-400 text-14">
                    Remaining Leaves
                    <LeavePopOver
                      cleanedData={cleanedData}
                      type="totalRemaining"
                    />{" "}
                  </p>
                </div>
              </div>
            </section>
            {/*<!-- /Leave Statistics -->*/}

            <div className="row">
              <div className="col-md-12">
                <div className="table-responsive">
                  <table className="table table-striped custom-table mb-0 datatable">
                    <thead>
                      <tr>
                        <th>Leave Type</th>
                        <th>From</th>
                        <th>To</th>

                        <th className=" text-nowrap">Total no of days</th>
                        <th className=" text-nowrap">No of days taken</th>
                        <th className=" text-nowrap">No of days left</th>
                        <th className=" text-nowrap">Active</th>
                        <th>Reason</th>
                        <th className="text-center">Status</th>
                        <th>Active</th>
                        {/* <th className="text-right">Actions</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {appliedLeaves.length
                        ? appliedLeaves.map((appliedLeave) => {
                            return (
                              <tr
                                onClick={() =>
                                  updatdeSelectedLeave(appliedLeave)
                                }
                              >
                                <td>{appliedLeave?.name}</td>
                                <td>
                                  {showDateInFormat(
                                    moment(appliedLeave?.from).format(
                                      "DD/MM/YYYY"
                                    ),
                                    appliedLeave?.from
                                  )}
                                </td>
                                <td>
                                  {showDateInFormat(
                                    moment(appliedLeave?.to).format(
                                      "DD/MM/YYYY"
                                    ),
                                    appliedLeave?.to
                                  )}
                                </td>
                                <td>
                                  {appliedLeave?.totalDays
                                    ? calculateDays(appliedLeave?.totalDays)
                                    : "---"}
                                </td>
                                <td>{calculateDays(appliedLeave?.days)}</td>
                                <td>
                                  {calculateDays(appliedLeave?.remaining)}
                                </td>
                                <td>
                                  {checkIfLeaveFinished(
                                    appliedLeave?.to,
                                    appliedLeave?.status
                                  )}
                                </td>

                                <td>{appliedLeave.reason}</td>
                                <td className="text-center">
                                  <div className="action-label">
                                    <span className="btn btn-white btn-sm btn-rounded">
                                      {appliedLeave.status === "New" ? (
                                        <i className="fa fa-dot-circle-o text-purple"></i>
                                      ) : appliedLeave.status === "Pending" ? (
                                        <i className="fa fa-dot-circle-o text-info"></i>
                                      ) : appliedLeave.status === "Approved" ? (
                                        <i className="fa fa-dot-circle-o text-success"></i>
                                      ) : (
                                        <i className="fa fa-dot-circle-o text-danger"></i>
                                      )}
                                      {appliedLeave.status}
                                    </span>
                                  </div>
                                </td>
                                <td>
                                  {checkIfLeaveFinished(
                                    appliedLeave?.to,
                                    appliedLeave?.status
                                  )}
                                </td>
                              </tr>
                            );
                          })
                        : ""}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          {/*<!-- /Page Content -->*/}

          {/*<!-- Add Leave Modal -->*/}
          {loggedEmployee ? (
            <ApplyLeaveModal
              updateAppliedLeavesList={updateAppliedLeavesList}
              employee={loggedEmployee}
              leaveTypes={leaveTypes}
            />
          ) : null}
          {/*<!-- /Add Leave Modal -->*/}

          {/*<!-- Edit Leave Modal -->*/}
          {/* <EditLeaveModal
            updateAppliedLeavesList={updateAppliedLeavesList}
            leaveTypes={leaveTypes}
            editLeave={selectedLeave}
          /> */}
          {/*<!-- /Edit Leave Modal -->*/}

          {/*<!-- Delete Leave Modal -->*/}
          {/* <DeleteLeaveModal
            removeLeaveFormAppliedLeavesList={removeLeaveFormAppliedLeavesList}
            deleteLeave={selectedLeave}
          /> */}
          {/*<!-- /Delete Leave Modal -->*/}
        </div>
        {/*<!-- /Page Wrapper -->*/}
      </div>
      {/*<!-- /Main Wrapper -->*/} {/* <!-- Sidebar Overlay --> */}
      <div className="sidebar-overlay" data-reff=""></div>
    </body>
  );
};

const mapStateToProps = (state) => {
  return {
    User: state.api.User,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(UserDashBoardLeaves));
